<svg
    viewbox="0 0 448 256"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
    d="M136.97 252.485L144.041 245.415C148.727 240.729 148.727
    233.131 144.041 228.444L60.113 145H436C442.627 145 448 139.627
    448 133V123C448 116.373 442.627 111 436 111H60.113L144.041
    27.556C148.727 22.87 148.727 15.272 144.041 10.585L136.97
    3.515C132.284 -1.171 124.686 -1.171 120 3.515L3.51499
    119.515C-1.17101 124.201 -1.17101 131.799 3.51499 136.486L120
    252.486C124.686 257.172 132.284 257.172 136.97 252.485Z" />
</svg>